<template>
    <div style="height:100%;overflow:hidden;position: relative;background: #eaeaea">
        <div class="top-field">
            <img src="../assets/img/query_bg.jpg" style="width: 100%"/>
        </div>
        <div class="relative-1">
            <!--<img style="width: 20px;margin-top: 20px;margin-left: 27px" src="../assets/img/return_trans.png" />-->
            <div class="title">预约挂号</div>
            <div class="form-panel">
                <!--<div class="form-item">-->
                <!--&lt;!&ndash;<div class="form-label">手机号码</div>&ndash;&gt;-->
                <!--<input v-model="form.phone" class="form-input" type="number" placeholder="请输入手机号码"/>-->
                <!--</div>-->
                <!--<div class="form-item">-->
                <!--<input v-model="form.name" class="form-input" placeholder="请输入您的姓名"/>-->
                <!--</div>-->
                <div class="form-item">
                    <input v-model="form.content" class="form-input" placeholder="请输入预约内容"/>
                </div>
                <div class="form-item" @click="isShowWkibeDat=true">
                    <div style="color: #aaaaaa;font-size: 14px" v-model="form.time" class="form-input">
                        {{form.time?utils.formatTimestamp(form.time):'请选择预约时间'}}
                    </div>
                </div>

<!--                <mt-datetime-picker-->
<!--                        ref="picker"-->
<!--                        :startDate="new Date()"-->
<!--                        type="datetime"-->
<!--                        class="form-input"-->
<!--                        @confirm="handleConfirm">-->
<!--                </mt-datetime-picker>-->
                <div style="font-size: 14px;padding: 10px 0px 0px 0px;text-indent:20px;">您正在进行的是在线预约申请，您提交申请后，我们将及时与您联系并确认信息。</div>
                <div style="font-size: 10px;color: grey">(预约时段我们将尽量为您安排，但可能存在调整，请您谅解)</div>
                <div class="form-item">
                    <div v-if="!success" @click="submit" v-model="form.time" class="form-button">立即预约申请</div>
                    <div v-else class="form-button success">预约成功</div>
                </div>
            </div>
        </div>
      <van-popup v-model="isShowWkibeDat" position="bottom">
        <van-datetime-picker
            type="datetime"
            id="relWkibedat"
            :filter="filter"
            @confirm="handleConfirm"
            @cancel="isShowWkibeDat=false"
            v-model='currentDate'
            active-class="active-style"
        />
      </van-popup>
    </div>
</template>

<script>
    import api from "../api";
    import utils from "../common/utils";
    import Vue from "vue";
    import {Indicator, Toast, MessageBox} from 'mint-ui';
    import { DatetimePicker,Popup } from 'vant';
    // Vue.component(DatetimePicker.name, DatetimePicker);
    Vue.use(DatetimePicker);
    Vue.use(Popup);
    export default {
        name: "RegistSubscribe",
        data() {
            return {
              isShowWkibeDat:false,
              currentDate:new Date(),
                YY_USER_ID: "",
                form: {
                    phone: "",
                    name: "",
                    content: "",
                    time: ""
                },
                success: false,
                time: "",
                hasBind: false,
                bindNo: "",
                utils: utils
            }
        },
        methods: {
          filter(type, options) {
            if (type === 'minute') {
              return options.filter((option) => option % 15 === 0);
            }
            return options;
          },
            submit: function () {

                if (!this.hasBind) {
                    MessageBox({
                        title: '提示',
                        closeOnClickModal:false,
                        message: '尚未绑定患者，请前往绑定?',
                        confirmButtonText: "前往绑定"
                    }).then(() => {
                        this.$router.push({
                            path: "/bindPatient",
                            query: {
                                YY_USER_ID: this.$route.query.YY_USER_ID,
                                openId: this.$route.query.openId
                            }
                        })
                    });
                    return;
                }

                var phoneReg = /^[1][3,4,5,7,8][0-9]{9}$/;
                // if (!phoneReg.test(this.form.phone)) {
                //     Toast("请填写正确的手机号码");
                //     return;
                // }
                // if (!this.form.name) {
                //     Toast("请填写您的姓名");
                //     return;
                // }
                if (!this.form.content) {
                    Toast("请填写预约内容");
                    return;
                }
                if (!this.form.time) {
                    Toast("请选择就诊时间");
                    return;
                }
                console.log(this.form);
                Indicator.open('加载中...');
                var url = "http://wx.kq123.com:10123/QSYYAjaxServer/PBClientTest?guid=" + this.$store.state.baseInfo.clientID + "&sql=nb>" + this.bindNo + "t>>" + Math.round(this.form.time / 1000) + "d>>tel2c>>【微信】" + this.form.content;
                api.corsGet(url, (res) => {
                    Toast(res);
                    console.log(res);
                    Indicator.close();
                    this.success = true;
                    setTimeout(() => {
                        history.back();
                    },3000);
                }, (err) => {
                    Indicator.close();
                    Toast("网络出错，请稍后再试");
                    console.log(err);
                })
            },
            handleConfirm: function (datetime) {
                this.form.time = datetime.getTime();
                this.isShowWkibeDat = false;
            },
            loadBindInfo: function () {
                var _this = this;
                var url = "http://wx.kq123.com:10123/QSYYAjaxServer/PBClientTest?guid=" + this.$store.state.baseInfo.clientID + "&sql=is>" + this.$route.query.openId;
                Indicator.open('加载中...');

                api.corsGet(url, (res) => {
                    Indicator.close();
                    if (res != "not find client") {
                        if (res == "") {
                            MessageBox({
                                title: '提示',
                                closeOnClickModal:false,
                                message: '尚未绑定患者，请前往绑定?',
                                confirmButtonText: "前往绑定"
                            }).then(() => {
                                this.$router.push({
                                    path: "/bindPatient",
                                    query: {
                                        YY_USER_ID: this.$route.query.YY_USER_ID,
                                        openId: this.$route.query.openId
                                    }
                                })
                            });
                        } else {
                            _this.hasBind = true;
                            _this.bindNo = res
                        }
                    } else {
                        Toast("诊所信息出错");
                    }
                }, (err) => {
                    Toast("网络出错，请稍后再试");
                    Indicator.close();
                    console.log(err);
                })
            }
        },
        created() {
            var _this = this;
            utils.doIF(() => {
                // _this.form.name = this.$store.state.baseInfo.name;
                _this.loadBindInfo();
            }, () => {
                console.log(23);
                return !!this.$store.state.baseInfo && this.$route.query.openId;
            });
        },
        mounted() {
            var _this = this;
        }
    }
</script>

<style scoped>
    .top-field {
        width: 100%;
        height: 0;
    }

    .title {
        color: white;
        font-size: 19px;
        padding: 23px;
        letter-spacing: 2px;
    }

    .title:after {
        content: "";
        display: block;
        width: 50px;
        height: 1px;
        background: white;
        margin-top: 15px;
    }

    .relative-1 {
        position: relative;
        z-index: 1;
    }

    .form-panel {
        margin: 30px 14px;
        background: white;
        border-radius: 7px;
        box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.19);
        padding: 31px 38px;
    }

    .form-item {
        background: #f1f0f1;
        border-radius: 100px;
    }

    .form-item > input {
        background: none;
        border: none;
        outline: none;
        box-shadow: none;
        color: #333333;
    }

    .form-item:not(:first-child) {
        margin-top: 18px;
    }

    .form-button {
        padding: 9px 22px;
        background: #43baeb;
        color: white;
        border-radius: 100px;
        margin-top: 18px;
        text-align: center;
        font-size: 14px;
        letter-spacing: 2px;
    }

    .form-button.success {
        background: #33aacb;
    }

    .form-button:active {
        background: #33aacb;
    }

    .form-input {
        width: 100%;
        padding: 10px 22px;
        box-sizing: border-box;
    }

    input::-webkit-input-placeholder {
        color: #aaaaaa;
    }
</style>

<style type="text/css">
    .picker-items{ width:100% }
</style>
